import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import store from '@/store'
import { clearLocal } from '@/util'
import { isEqual } from 'lodash'
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/api/' : window.config.baseUrl

const pending = []
const CancelToken = axios.CancelToken

const removePending = (config) => {
  for (const p in pending) {
    if (pending[p].u === config.url && isEqual(config.params, pending[p].p) && pending[p].d === config.data) {
      pending[p].f()
      pending.splice(p, 1)
    }
  }
}

// request拦截器
axios.interceptors.request.use(config => {
  removePending(config)

  config.cancelToken = new CancelToken(c => {
    pending.push({ u: config.url, f: c, p: config.params || '', d: config.data || '' })
  })

  if (localStorage.pc_token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers.clearauthtoken = localStorage.pc_token
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

axios.interceptors.response.use(res => {
  if (res.data.resCode === 200) {
    if (
      res.config.url.indexOf('app/user/phonelogin') > -1 ||
      res.config.url.indexOf('app/verificationcode') > -1
    ) {
      localStorage.pc_token = res.headers.clearauthtoken
    }
    return res
  } else if (typeof res.data === 'string' && res.data.trim() === 'access denied') {
    clearLocal('tmly_username')
    clearLocal('pc_token')
    store.commit('setUsername', null)
    router.push('/login')
    return Promise.reject(new Error(res.data))
  } else if (typeof res.data === 'object' && res.data.errInfo) {
    Message.error(res.data.errInfo)
    return Promise.reject(new Error(res.data))
  } else {
    return Promise.reject(new Error(res.data))
  }
}, error => {
  error.message && Message({
    message: '网络出错',
    type: 'error'
  })
  return Promise.reject(error)
})

export default axios
